import React from 'react';

// Non-blocking indicator shown above stale cached data while a background refetch is in flight.
const UpdatingBanner = ({ text = 'Updating forecast...' }) => {
    return (
        <div className="flex items-center gap-2 mb-2 px-3 py-1.5 bg-custom-light-blue/10 border border-custom-light-blue/30 rounded">
            <div className="w-3 h-3 border-2 border-custom-light-blue/30 border-t-custom-light-blue rounded-full animate-spin"></div>
            <p className="text-xs text-custom-light-blue font-medium">{text}</p>
        </div>
    );
};

export default UpdatingBanner;
